// Contexts
import { ModalConfig } from '../../../../contexts/modalContext';

// Modals
import { PlanSummaryModals } from './planSummaryModals';
import APTCFailureModal from './APTCFailureModal';
import APTCSuccessModalContainer from './APTCSuccessModalContainer';

export const planSummaryModalConfig: ModalConfig = {
    [PlanSummaryModals.APTCSuccess]: {
        id: PlanSummaryModals.APTCSuccess,
        modalComponent: APTCSuccessModalContainer,
    },
    [PlanSummaryModals.APTCFailure]: {
        id: PlanSummaryModals.APTCFailure,
        modalComponent: APTCFailureModal,
    },
};
